import React from "react"
import "./style.scss"
import Layout from "../../../components/layout/layout"
import bannerImage from "./banner.svg"
import tss from "../../../images/tss.svg"
import tWorldwide from "../../../images/tWorldwide.svg"
import drivex from "../../../images/drivex.svg"
import ServiceHeader from "../../../components/serviceCards/serviceHeader"
import OverviewSection from "../../../components/serviceCards/overviewSection"
import ServicesSection from "../../../components/serviceCards/servicesSection"
import PointsSection from "../../../components/serviceCards/pointsSection"
import BookingSection from "../../../components/serviceCards/bookingSection"
import CustomerSection from "../../../components/serviceCards/customerSection"
import RelatedArticles from "../../../components/cards/relatedarticles/RelatedArticles"
import { graphql } from "gatsby"
import SEO from "../../../components/seo"

const DataAsService = ({ data, location: { pathname } }) => {
  const datas = {
    title:
      "Enhance the data outreach with our DaaS (Data as a service) platform.",
    text:
      "Make enterprise data accessibility more maintained, affordable, and secure.",
    overviewTitle: "Overview - Data as a Service",
    overviewText: [
      "With the advent of cutting-edge information technologies, businesses now seek highly agile and effective data management services to store, integrate, process, and analyze services over a reliable network. And that is all that data as a service (DaaS) is about. And with the Wersel DaaS, you get a highly secure, stable, and fast data management strategy.",
      <br />,
      <br />,
      "Like the cloud computing services that allow multiple users to access and operate different applications over a secure network without installing them locally on the device, Wersel, with its highly nimble DaaS, enables the users to store, integrate, and process the operations over a secure, reliable network.",
      <br />,
      <br />,
      "Our services enable enterprises to access and process the data on-demand without any geographical or organizational restrictions by connecting the data users and data service providers. DaaS effectively reduces delays and costs of mining, mapping, and scraping the data by incorporating it into a comprehensive format to make a cumulative data-set that microservices can utilize.",
    ],
    serviceSubtitle: "Wersel’s impeccable DaaS includes -",
    services: [
      {
        title: "Deliver ready to use data prepared by the vendor",
        content:
          "Our data services are very efficient and very prompt, the reason being compelling data storing and preparation from the vendor's end. We cleanse the data ourselves and maintain the quality of the downstream services. We provide the data in an appropriate ready-to-use format to save the client time and money.",
      },
      {
        title: "Data integration ",
        content:
          "The data services that we provide can be integrated into pre-existing, more extensive data sets for enhancing the analytical validity without hampering the data quality. We eliminate the uncertainty of data management that comes following new data addition.",
      },
      {
        title: "Prompt data uptation",
        content:
          "At Wersel, we believe that it's the vendor's responsibility to gather, refine, and update data to make it readily available for the applications.",
      },
    ],
    whyPartnerWerselTitle: "Why Partner with Wersel Workdesk?",
    whyPartnerWerselText:
      "Data as a service has multiple privileges over locally housing a data storing and management unit. Like any other cloud computing service, the Wersel DaaS also lets you access promptly updated real-time data that has been cleansed to minimize data wastage and save your time. Here are some key benefits you get by partnering with Wersel-",
    points: [
      {
        title: "Cost-effective",
        content:
          "By incorporating the DaaS solutions, you can substantially reduce the costs associated with data storage, management, and processing. Besides, the enterprises can effortlessly increase or decrease the cloud resources allocation as per change in the exact needs.",
      },
      {
        title: "Highly flexible",
        content:
          "You can instantly allocate as many resources as you want using the cloud data workloads, making it highly flexible and easily optimizable s compared to the on-premise data unit.",
      },
      {
        title: "Enhanced functionality",
        content:
          "The cloud services have a robust infrastructure that is pretty much immune to disruptions and downtimes, making DaaS a highly functional solution.",
      },
      {
        title: "Highly secure",
        content:
          "Wersel mitigates the data transit security risks by incorporating encryption techniques while moving the data over the network.",
      },
      {
        title: "Automatic maintenance",
        content:
          "With our DaaS solutions, you won't have to worry about maintenance at all, as we keep the platform up-to-date.",
      },
      {
        title: "Less set-up time",
        content: "Immediate data storing and processing is the USP of Wersel.",
      },
    ],
    howItWorksTitle:
      "Leverage the best data practices to make an impact on your business",
    howItWorks:
      "Go ahead! Check for yourself the benefits of DaaS offered by our company. Connect with us now.",
    customers: [
      {
        name: "George",
        description: "Chief Executive Officer (CEO) - TSS",
        commentTitle: "They made My Business",
        comment:
          "We approach Datinfi based on their expirience in handling AI & ML Models, and the team did not dissappoint. They helped me to expand my business with more retailers and also increased 30% in my monthly recurring revenue",
        image: tss,
        id: 1,
      },
      {
        name: "Chris Shargunan",
        description: "Chief Technology Officer (CTO) - DriveX",
        commentTitle: "They made My Business",
        comment:
          "We developed a great rapport eith Datinfi and their dedication to our web portal development is evident in all aspects of the site. We appriciate their attention to detail and creative approach to bringing our new exhibit to life online",
        image: tWorldwide,
        id: 2,
      },
      {
        name: "Veles Nalliah",
        description: "BIIT Consulting",
        commentTitle: "They made My Business",
        comment:
          "Well! Wersel business app with analytics, becoming the core component of our business decision-making process. Datinfi has been a superior company to do the business with",
        image: drivex,
        id: 3,
      },
    ],
  }
  const {
    title,
    text,
    overviewTitle,
    overviewText,
    whyPartnerWerselTitle,
    whyPartnerWerselText,
    services,
    serviceSubtitle,
    points,
    howItWorks,
    howItWorksTitle,
    customers,
  } = datas
  console.log("services", services.serviceSubtitle)
  return (
    <Layout withBrand slidePosition={0}>
      <SEO
        title="Enhance The Data Outreach With Our Data as a Service Platform"
        description="Make enterprise data accessibility more maintained, affordable, and secure. With the Wersel data as a service, you get a highly secure, stable, and fast data management strategy."
        keywords="data service, data as a service, data provider company, data scraping companies, enterprise data management services"
        url="http://www.wersel.io/solutions/data-as-service"
      />
      <div className="services">
        <ServiceHeader title={title} text={text} image={bannerImage} />
        <OverviewSection
          overviewTitle={overviewTitle}
          overviewText={overviewText}
        />
        <ServicesSection
          services={services}
          serviceSubtitle={serviceSubtitle}
        />
        <OverviewSection
          overviewTitle={whyPartnerWerselTitle}
          overviewText={whyPartnerWerselText}
        />
        <PointsSection points={points} />
        <BookingSection
          howItWorksTitle={howItWorksTitle}
          howItWorks={howItWorks}
        />
        {/* <CustomerSection customers={customers} /> */}
        <RelatedArticles
          path={pathname}
          posts={data.posts.edges}
          title="Related Articles"
        />
      </div>
    </Layout>
  )
}
export const pageQuery = graphql`
  query DataAsService {
    posts: allMarkdownRemark {
      edges {
        node {
          id
          frontmatter {
            title
            path
            description
          }
        }
      }
    }
  }
`
export default DataAsService
